export default class A11yHelpers {
    static onClickOrKeyPress(func, keys = []) {
        if (!func) {
            return {};
        }
        const onKeyPress = (e) => {
            if (keys.includes(e.key)) {
                func(e);
            }
        };
        return {
            onClick: func,
            onKeyPress,
        };
    }
    /**
     * Fires a handler when an element is clicked, or when it's focused and enter or space is pressed.
     * Especially useful for when anchor elements need to behave like buttons.
     *
     * @example
     * <a
     *    role="button"
     *    className="btn btn-link"
     *    {...A11yHelpers.onClickOrEnterOrSpace(()=>setIsModalOpen(true))}
     * >
     *     Open modal
     * </a>
     *
     *
     * @param {T} func - event handler
     * @returns {{onClick: T, onKeyPress: function(KeyboardEvent): void}} react event handlers that should be spread onto the element.
     */
    static onClickOrEnterOrSpace(func) {
        return A11yHelpers.onClickOrKeyPress(func, ["Enter", "Space", " "]);
    }
}
